import { ChangeEvent, FC, useState } from "react";
import { Button, Drawer, Flex, Input, LegacyForm, Typography } from "@payping/web-components";
import { Close } from "@payping/icons";
import { useAppSelector, useAppTranslation } from "@/utils";
import { ValidPersianName } from "@payping/utils/validation";
import EditActionButtons from "@/components/mobile/settings/EditActionButtons";
import { isPersonalDisable } from "@/mobile/Settings/Personal/Edit/isPersonalDisable";
import { DashboardRoutes } from "@/router";
import { useHandleNavigationURL, useSaveToRedux } from "../utils";
import { settingsPersonalAtom } from "../../state";
import { selectAtom } from "jotai/utils";
import { useAtom } from "jotai";

const mobileFormEditAtom = selectAtom(settingsPersonalAtom, (val) => val.mobileFormEdit);

const MobileEditPersonalName: FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const [form] = LegacyForm.useForm();

  const { t } = useAppTranslation();
  const [mobileFormEditState] = useAtom(mobileFormEditAtom);

  const firstNameApi = useAppSelector((state) => state.user.personalInfo?.firstName);

  const [firstName, setFirstName] = useState<string | undefined>();

  // Custom Hooks
  const { handleNavigationURL } = useHandleNavigationURL();
  const { saveToRedux } = useSaveToRedux();

  return (
    <>
      <Drawer
        open={isDrawerOpen}
        title={`${t("edit")} / ${t("name")}`}
        size={"100%"}
        placement={"bottom"}
        closeIcon={false}
        extra={<Button type={"text"} icon={<Close width={14} height={14} />} onClick={handleNavigationURL} />}
      >
        <Flex vertical>
          <LegacyForm
            onFinish={() =>
              saveToRedux({
                nextUrlForMobileRegisterURL: DashboardRoutes.register.mEditPersonal.lastName.url,
                fieldName: "firstName",
                fieldValue: firstName,
                setIsDrawerOpen,
              })
            }
            form={form}
            initialValues={{ firstName: mobileFormEditState.firstName ?? firstNameApi }}
          >
            <LegacyForm.Item
              name="firstName"
              rules={[
                () => ({
                  validator(_, value): Promise<void> {
                    if (ValidPersianName(value)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error(t("profile.validFirstName")));
                  },
                }),
                { required: true },
              ]}
            >
              <Input
                value={firstName}
                placeholder={t("mobileEditPersonal.enterField", { fieldName: t("common.firstName") })}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setFirstName(e.target.value)}
                disabled={isPersonalDisable()}
              />
            </LegacyForm.Item>
          </LegacyForm>

          <Typography.Text type={"secondary"}>
            {t("settings.personal.instructions.firstNameAndLastName")}
          </Typography.Text>
        </Flex>
      </Drawer>
      <EditActionButtons onAccept={form.submit} />
    </>
  );
};

export default MobileEditPersonalName;
